import { useEffect, useState } from "react";
import swal from "sweetalert";
import {
  GET_ALL_PENDING_WITHDRAWL,
  UPDATE_WITHDRAWL,
} from "../../../../utils/constant";
import useApiServices from "../../../../utils/useApiServices";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import DropCredit from "./DropCredit";
import ManualUpload from "./ManualUpload";
import UploadIcon from "@mui/icons-material/Upload";
import CustomTip from "../../../../common/CustomToolTip/CustomTip";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import MyModal from "./MyModel";
import { ToolsActionRegistry } from "../../../../Privillages/ActionRegistry";
import useHasPrivilege from "../../../../Privillages/useHasPrivilege";

function RequestedWithdraw({ toggleRightBar }) {
  const {
    TOOLS_WITHDRAW,
    MANUAL_REQUEST_EDIT,
    DROP_CREDIT_EDIT,
    WITHDRAW_REQUEST_APPROVE_REJECT,
  } = ToolsActionRegistry;
  const hasDropCreditEdit = useHasPrivilege(TOOLS_WITHDRAW, DROP_CREDIT_EDIT);
  const hasManualRequestEdit = useHasPrivilege(
    TOOLS_WITHDRAW,
    MANUAL_REQUEST_EDIT
  );
  const hasWithdrawEdit = useHasPrivilege(
    TOOLS_WITHDRAW,
    WITHDRAW_REQUEST_APPROVE_REJECT
  );
  const [withdrawData, setWithdrawData] = useState([]);
  const [callAgain, setCallagain] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [type, setType] = useState(null);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [pendingPayoutAmount, setPendingPayoutAmount] = useState(false);
  const [pendingAcAmount, setPendingAcAmount] = useState(false);

  const { apiCallFnforPut, apiCallFnforGet } = useApiServices();

  const handleClick = (id, type) => {
    setShowModal(true);
    setSelectedId(id);
    setType(type);
  };

  const getSelectedWithdrawalData = (selectedId) => {
    return withdrawData.find((item) => item.withdrawalId === selectedId);
  };

  const performApprovalOrRejection = (id, type, data, date, remark) => {
    const selectedWithdrawal = getSelectedWithdrawalData(id);

    const RETURNPAYLOAD = (type) => {
      if (!type) {
        return {
          transactionDate: date,
          utr: data,
          status: "success",
          withdrawalId: id,
          remark: "",
        };
      } else {
        return {
          transactionDate: "",
          utr: "",
          status: "reject",
          withdrawalId: id,
          remark: remark,
        };
      }
    };

    const requestData = RETURNPAYLOAD(type);

    apiCallFnforPut(UPDATE_WITHDRAWL, requestData)
      .then((response) => {
        if (response.statusCode === 200) {
          swal({
            title: "Success",
            text: type
              ? "Your application has been rejected."
              : "Your application has been approved.",
            icon: "success",
          });
          setTimeout(async () => {
            GetAllPendingRequest();
          }, 2000);
        } else {
          swal({
            title: "Error",
            text: "Something went wrong. Please try again.",
            icon: "error",
          });
        }
        setShowModal(false);
      })
      .catch((error) => {
        console.error("Error performing approval/rejection:", error);
        swal({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
        });
        setShowModal(false);
      });
  };

  const GetAllPendingRequest = async () => {
    try {
      const response = await apiCallFnforGet(GET_ALL_PENDING_WITHDRAWL); // Ensure async

      if (response?.statusCode === 200) {
        // alert("Data fetched successfully");
        const filteredPayoutData = response.data?.filter(
          (item) => item.transferType === "payout" && item.status === "pending"
        );

        const filteredAccountData = response.data?.filter(
          (item) => item.transferType === "account" && item.status === "pending"
        );

        const totalPayoutAmount = filteredPayoutData?.reduce(
          (acc, item) => acc + Number(item.amount || 0),
          0
        );

        setPendingPayoutAmount(totalPayoutAmount);

        const totalAccountAmount = filteredAccountData?.reduce(
          (acc, item) => acc + Number(item.amount || 0),
          0
        );
        setPendingAcAmount(totalAccountAmount);

        const finalRes = response?.data?.map((item, i) => ({
          id: i + 1,
          ...item,
          action: hasWithdrawEdit ? (
            <div className="d-flex gap-1 mt-2">
              <button
                className="badge badge-rounded badge-success"
                onClick={() => handleClick(item.withdrawalId, false)}
              >
                Approve
              </button>
              <button
                className="badge badge-rounded badge-danger"
                onClick={() => handleClick(item.withdrawalId, true)}
              >
                Reject
              </button>
            </div>
          ) : null,
        }));

        setWithdrawData(finalRes); // Now it's inside the correct block
      } else {
        setWithdrawData([]);
      }
    } catch (error) {
      console.error("Error fetching withdrawal data:", error);
    }
  };

  useEffect(() => {
    GetAllPendingRequest();
  }, [callAgain]);

  const columns = [
    { headerName: "Merchant Id", field: "mid", minWidth: 150 },
    { headerName: "Merchant Name", field: "fullName", minWidth: 150 },
    { headerName: "Email Id", field: "emailId", minWidth: 150 },
    { headerName: "Transfer Type", field: "transferType", minWidth: 150 },
    { headerName: "Requested Amount", field: "actualAmount", minWidth: 100 },
    { headerName: "Amount", field: "amount", minWidth: 100 },
    { headerName: "Service Charge", field: "serviceCharge", minWidth: 100 },
    { headerName: "GST Charge", field: "gstCharge", minWidth: 100 },
    {
      headerName: "Virtual Account Type",
      field: "virtualAccountType",
      minWidth: 150,
    },
    {
      headerName: "Virtual Account Number",
      field: "virtualAccountNumber",
      minWidth: 150,
    },
    { headerName: "Virtual IFSC Code", field: "ifsc", minWidth: 150 },
    { headerName: "Bank Name", field: "bankName", minWidth: 150 },
    { headerName: "Status", field: "status", minWidth: 100 },
    { headerName: "Created Date", field: "createDate", minWidth: 150 },
    { headerName: "Created Time", field: "createTime", minWidth: 150 },
    { headerName: "Action", field: "action", minWidth: 150 },
  ];

  const handleOnClick = () => {
    setShow(true);
  };
  const handleOnClick2 = () => {
    setShow2(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleClose2 = () => {
    setShow2(false);
  };

  return (
    <>
      <div className="container-fluid">
        <div className=" d-flex justify-content-between bg-white">
          <div className="d-flex justify-content-start align-items-center">
            <button
              type="button"
              className="btn-close m-3"
              onClick={toggleRightBar}
            ></button>
            <div className="fs-2 text-dark fw-bold">Requested Withdraw</div>
          </div>

          <div className="d-flex gap-2 justify-content-end me-2 mt-3 mb-2">
            {hasDropCreditEdit ? (
              <div className="d-flex justify-content-end">
                <CustomTip size="18" placement="top" title="Drop Credit">
                  <div className="" onClick={handleOnClick}>
                    <CreditScoreIcon fontSize="large" />
                  </div>
                </CustomTip>
              </div>
            ) : null}

            {hasManualRequestEdit ? (
              <div className="d-flex justify-content-end">
                <CustomTip size="18" placement="top" title="Manual Upload">
                  <div className="" onClick={handleOnClick2}>
                    <UploadIcon fontSize="large" />
                  </div>
                </CustomTip>
              </div>
            ) : null}
          </div>
        </div>
        <div className="d-flex justify-content-around bg-white">
          <div className="d-flex justify-content-start align-items-center border border-dark px-4 py-2 rounded">
            <span className="fs-3 font-bold text-dark">
              Pending Payout ( IMPS ) : {pendingPayoutAmount}
            </span>
          </div>
          <div className="d-flex justify-content-start align-items-center border border-dark px-4 py-2 rounded">
            {/* <div className="d-flex justify-content-start align-items-center"> */}
            <span className="fs-3 font-bold text-dark">
              Pending Account : {pendingAcAmount}
            </span>
          </div>
        </div>
        <div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="col-12">
                  <div className="card-body">
                    <div className="table-responsive">
                      <DataGrid
                        rows={withdrawData}
                        columns={columns.map((column) => ({
                          ...column,
                          renderCell: (params) =>
                            column.field === "action"
                              ? params.value
                              : params.value,
                        }))}
                        slots={{
                          toolbar: GridToolbar,
                        }}
                        slotProps={{
                          toolbar: {
                            showQuickFilter: true,
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showModal && (
            <MyModal
              id={selectedId}
              showModal={showModal}
              setShowModal={setShowModal}
              type={type}
              performApprovalOrRejection={performApprovalOrRejection}
            />
          )}
        </div>
        <DropCredit
          onHide={handleClose}
          show={show}
          setRefresh={setRefresh}
          refresh={refresh}
          GetAllPendingRequest={GetAllPendingRequest}
        />
        <ManualUpload
          onHide={handleClose2}
          show={show2}
          setRefresh={setRefresh}
          refresh={refresh}
          GetAllPendingRequest={GetAllPendingRequest}
        />
      </div>
    </>
  );
}

export default RequestedWithdraw;
